import App from 'app/app.js';

function ContentJobTypeMappingService(JobStore) {
  var contentMap = new Map();
  //Fall individuals
  contentMap.set('FALL_INDIVIDUALS', 'FALL_INDIVIDUALS');
  //Spring individuals
  contentMap.set('SPRING_INDIVIDUALS', 'SPRING_INDIVIDUALS');
  //Underclass Grads
  contentMap.set('UNDERCLASS_GRADS', 'UNDERCLASS_GRADS');
  contentMap.set('COMMENCEMENTS', 'UNDERCLASS_GRADS');
  contentMap.set('COLLEGE_SENIORS', 'UNDERCLASS_GRADS');
  contentMap.set('SENIORS_CAP_AND_GOWN', 'UNDERCLASS_GRADS');
  contentMap.set('PRESTIGE_SENIOR_PORTRAITS', 'UNDERCLASS_GRADS');
  //Special Events Other
  contentMap.set('SPECIAL_EVENTS_OTHER', 'SPECIAL_EVENTS_OTHER');
  contentMap.set('DANCE', 'SPECIAL_EVENTS_OTHER');
  contentMap.set('BANDS_AND_FESTIVALS', 'SPECIAL_EVENTS_OTHER');
  contentMap.set('SERVICE_NON_REV', 'SPECIAL_EVENTS_OTHER');
  contentMap.set('OTHER_STUDIO_STYLE_PHOTOGRAPHY', 'SPECIAL_EVENTS_OTHER');
  //Groups
  contentMap.set('GROUPS', 'GROUPS');
  contentMap.set('CLASSROOM_GROUPS', 'GROUPS');
  contentMap.set('PANORAMIC_GROUPS', 'GROUPS');
  //Sports
  contentMap.set('SPORTS', 'SPORTS');
  //Yearbook
  contentMap.set('YEARBOOK', 'YEARBOOK');

  this.mapSubprogram = function () {
    if (contentMap.has(JobStore.getSubProgramName().replace(/ /g, '_').toUpperCase())) {
      return contentMap.get(JobStore.getSubProgramName().replace(/ /g, '_').toUpperCase());
    } else {
      return 'FALL_INDIVIDUALS';
    }
  };
}

App.service('ContentJobTypeMappingService', ['JobStore', ContentJobTypeMappingService]);
